import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Legend, Tooltip } from 'recharts';

import { Divider } from 'uiToolkitV1/Divider';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyLarge, TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

export const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <PaperWithShadow p={2} width="264px" boxShadow="0px 2px 8px rgba(0, 0, 0, 0.08)">
        <Box py={1} px={2}>
          <TextBodyLarge bold color="text.g1">
            {label}
          </TextBodyLarge>
        </Box>
        <Divider color="neutral.F2F2F2" my={1} />
        {payload.map(({ dataKey, color, value }) => (
          <Flex justify="space-between" p="2px 8px">
            <Flex alignItems="center" gap="8px">
              <Box width="8px" height="8px" borderRadius="2px" bg={color} />
              <TextBodyMedium color="text.g1">{dataKey}</TextBodyMedium>
            </Flex>
            <TextBodyMedium color="text.g1">{value}</TextBodyMedium>
          </Flex>
        ))}
      </PaperWithShadow>
    );
  }

  return null;
};

const CustomLabel = ({ payload, ...rest }) => (
  <foreignObject className="node" x={rest.x} y={rest.y} width={150} height={35}>
    <div>
      <text
        className="recharts-text recharts-cartesian-axis-tick-value"
        stroke="none"
        fill="#666"
        textAnchor={rest.textAnchor}
        radius={rest.radius + 100}
        cx={rest.cx - 20}
        cy={rest.cy - 20}
      >
        <TextLabel>{payload.value}</TextLabel>
      </text>
    </div>
  </foreignObject>
);

export const SpiderChart = ({ data, labelDetails, height = 400, isBigChart = false }) => (
  <Flex justifyContent="center">
    <RadarChart
      // this id is specifically for the chart rendered to be screenshot by puppeteer, for the PDF
      id="review-result-spider-chart"
      // cx={300}
      // cy={250}
      // outerRadius={150}
      width={height + 300}
      height={height}
      data={data}
    >
      <PolarGrid gridType="circle" strokeDasharray={[3, 3]} />
      <PolarAngleAxis dataKey="label" tick={<CustomLabel />} />
      <PolarRadiusAxis
        tickCount={(data?.[0]?.maxRating ?? 5) + 1}
        domain={[0, data?.[0]?.maxRating ?? 5]}
        type="number"
        tick={false}
        axisLine={false}
      />
      {labelDetails?.map((item) => (
        <Radar
          name={item.description}
          dataKey={item.key}
          stroke={item.color}
          fill={item.color}
          fillOpacity={0.4}
          isAnimationActive={!isBigChart}
        />
      ))}
      <Tooltip content={<CustomTooltip />} allowEscapeViewBox={{ x: true, y: true }} />
      <Legend />
    </RadarChart>
  </Flex>
);
